import OrganisationIndex from "../../organisations/model/OrganisationIndex";
import { formatBooleanValue } from "../../util";
import DocumentTypeIndexCategory from "../model/DocumentTypeIndexCategory";

const DocumentTypeIndexCategoryMapper = (item: any) => {
  let legalViewTypeIndexCategory = DocumentTypeIndexCategory(item);
  legalViewTypeIndexCategory.valid = formatBooleanValue(item.valid);
  legalViewTypeIndexCategory.required = formatBooleanValue(item.required);
  legalViewTypeIndexCategory.organisationIndexList = (
    item.organisationIndexList || []
  ).map((index) => OrganisationIndex(index));
  return legalViewTypeIndexCategory;
};

export default DocumentTypeIndexCategoryMapper;
